<template>
  <el-row class="page-fitter">
    <el-date-picker
      v-model="fitter.month"
      @change="changeMonth"
      type="month"
      value-format="yyyy-MM"
      size="small"
      placeholder="选择月">
    </el-date-picker>
    <el-cascader
      v-model="fitter.convert"
      size="mini"
      clearable
      filterable
      placeholder="请选择人员"
      collapse-tags
      :show-all-levels="false"
      :props="props"
     :options="adminUsersLists"
     @change="convertChange">
    </el-cascader>
  </el-row>
</template>

<script>
export default {
  name: 'OrderViewFitter',
  components: {  },
  props: {
    fitter: {
      type: Object,
      default: () => {
        return {}
      }
    },
    adminUsersLists: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      props: { multiple: true, emitPath: false }
    }
  },
  methods: {
    changeMonth (val) {
      this.$emit('changeNowDate', val)
    },
    convertChange (val) {
      console.log(val)
      this.$emit('convertChange', val)
    }
  }
}
</script>

<style lang="stylus" scoped>
.page-fitter >>> .el-input {
  width: auto;
}
.el-form-item {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/data_overview/common/OrderViewFitter.vue